import { getServerTime as getServerTimeCommon } from '@tencent/wphk-components-common/utils/server-time';
import dayjs from 'dayjs';
import IsSameOrBefore from 'dayjs/plugin/isSameOrBefore.js';
dayjs.extend(IsSameOrBefore);

// 封装一些跟时间有关的工具函数：
// - TODO: 时间展示格式化

/**
 * 获取本月的第一天和最后一天
 * @returns firstDay, lastDay
 */
export const getMonthPeriod = () => {
  const systemTime = getServerTime();
  const firstDate = dayjs(systemTime).startOf('month')
    .toDate();
  const lastDate = dayjs(systemTime).endOf('month')
    .toDate();
  return { firstDate, lastDate };
};

/** 获取当前月份，格式YYYYMM */
export const getCurMonth = () => dayjs(getServerTime()).format('YYYYMM');

/**
 * 获取当前系统时间。
 * @returns Date
 */
export const getServerTime = () => getServerTimeCommon();;

/**
 * 校验某时间是否在开始和结束时间之间,闭区间（不使用mock时间）
 * @param targetTime 目标时间
 * @param startDate 开始时间-类型Date
 * @param endDate 结束时间-类型Date
 * @returns boolean
 */
export function checkTimeBetween({ targetTime, startDate, endDate }: {
  startDate: Date,
  endDate: Date,
  targetTime: Date | string
}): boolean {
  if (!targetTime || !startDate || !endDate) {
    throw new Error('[checkTimeBetween]: params missing');
  }
  return dayjs(startDate).isSameOrBefore(dayjs(targetTime)) && dayjs(targetTime).isSameOrBefore(dayjs(endDate));
}
